import { Injectable } from '@angular/core';
import { ApiActions } from '../common/util.service';
import { Subject } from 'rxjs';
import { PostAttachments,Country,State, ServiceActions, Variants, Authors, Category, ProductMaster, Posts } from 'src/app/model';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../common/app-config.service';
import { CommonDataService } from '../common/common-data.service';
import { MsgService } from 'src/app/service';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class PostAttachmentsService implements ServiceActions {

  public pageName = 'PostAttachments';
  public dataList = new Subject<Array<PostAttachments>>();

  constructor(
    private http: HttpClient,
    private config: AppConfigService,
    private common: CommonDataService,
		private msgSvc: MsgService,
		private router: Router
  ) { }

  private getUrl(apiOption: ApiActions) {
    return this.config.ipAddress + this.config.PostAttachmentsApi[apiOption];
  }

  public getDataRecords() {

    this.http.post(this.getUrl(ApiActions.Get), null, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          const dataArray: Array<PostAttachments> = [];
          response.result.Attachments.map(element => {
            element.status = element.rec_status == '1' ? true : false;
            dataArray.push(element);
          });
          this.dataList.next(dataArray);
        }
      },
        err => {
            this.msgSvc.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
  }

  public getPosts(): Subject<Array<Posts>> {
    const url = this.config.ipAddress + this.config.PostsApi[ApiActions.Get];
    const dataArray: Array<Posts> = [];
    const data = new Subject<Array<Posts>>();
    this.http.post(url, null, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          response.result.Posts.map(element => {
            element.status = Number(element.rec_status) === 1 ? true : false;
            dataArray.push(element);
          });
          data.next(dataArray);
        }
      },
        err => {
            this.msgSvc.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
    return data;
  }

  public addData(objData: PostAttachments) {
    const fData = this.fillData(objData);
    return this.common.executeAction(fData, this.getUrl(ApiActions.Create), this.pageName);
  }

  private fillData(objData: PostAttachments) {
    const fData = new FormData();
    fData.append('attach_id', objData.attach_id + '');
    fData.append('attach_type_id', objData.attach_type_id + '');
    fData.append('attach_desc', objData.attach_desc);
    fData.append('attach_name', objData.attach_name);
    fData.append('rec_status', objData.rec_status ? '1' : '0');

    return fData;
  }

  public updateData(objData: PostAttachments) {
    const fData = this.fillData(objData);
    console.log(fData);
    //return false
    return this.common.executeAction(fData, this.getUrl(ApiActions.Update), this.pageName);
  }

  public deleteData(id: number) {
    const fData = new FormData();
    fData.append('attach_id', id + '');
    return this.common.executeAction(fData, this.getUrl(ApiActions.Delete), this.pageName);
  }

  public updateStatus(objData: PostAttachments) {
    const fData = new FormData();
    fData.append('rec_status', objData.rec_status ? '1' : '0');
    fData.append('attach_id', objData.attach_id + '');
    return this.common.executeAction(fData, this.getUrl(ApiActions.UpdateStatus), this.pageName);
  }

 

}
